exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-8adc895a] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-8adc895a] {\n  width: 100%;\n}\n.h2_title[data-v-8adc895a] {\n  text-align: left;\n  color: grey;\n}\n", ""]);

// exports
